import {
  CUSTOMER_GROUP_LOADING,
  GET_CUSTOMER_GROUP,
  GET_CUSTOMER_GROUP_SUCCESS,
  GET_CUSTOMER_GROUP_FAIL,
  ADD_CUSTOMER_GROUP_SUCCESS,
  ADD_CUSTOMER_GROUP_FAIL,
  DELETE_CUSTOMER_GROUP_SUCCESS,
  DELETE_CUSTOMER_GROUP_FAIL,
  UPDATE_CUSTOMER_GROUP_SUCCESS,
  UPDATE_CUSTOMER_GROUP_FAIL,
  CUSTOMER_GROUP_RESET,
  CUSTOMER_GROUP_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  customerGroups: [],
  customerGroupAdded: {},
  error: {},
};

const CustomerGroup = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMER_GROUP_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CUSTOMER_GROUP:
          return {
            ...state,
            customerGroups: action.payload.data,
            isCustomerGroupCreated: false,
            isCustomerGroupSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CUSTOMER_GROUP_FAIL:
      switch (action.payload.actionType) {
        case GET_CUSTOMER_GROUP_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCustomerGroupCreated: false,
            isCustomerGroupSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CUSTOMER_GROUP: {
      return {
        ...state,
        isCustomerGroupCreated: false,
        loading: true,
      };
    }

    case CUSTOMER_GROUP_LOADING: {
      return {
        ...state,
        isCustomerGroupCreated: false,
        loading: true,
      };
    }

    case ADD_CUSTOMER_GROUP_SUCCESS:
      return {
        ...state,
        isCustomerGroupCreated: true,
        loading: false,
        customerGroups: [action.payload.data, ...state.customerGroups],
        customerGroupAdded: action.payload.data,
      };

    case ADD_CUSTOMER_GROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CUSTOMER_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        customerGroups: state.customerGroups.filter(
          customerGroup => customerGroup.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CUSTOMER_GROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CUSTOMER_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        customerGroups: state.customerGroups.map(customerGroup =>
          customerGroup.id.toString() === action.payload.data.id.toString() ? { ...customerGroup, ...action.payload.data } : customerGroup
        ),
      };

    case UPDATE_CUSTOMER_GROUP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CUSTOMER_GROUP_RESET_CREATE:
      return {
        ...state,
        isCustomerGroupCreated: false,
      };

    case CUSTOMER_GROUP_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CustomerGroup;